define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var AgentGroupUtilities = require("user-management-utils/AgentGroupUtilities");

    var AgentGroupMoveFilters = [];

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        AgentGroupMoveFilters = [{
            name: "name",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function (options) {
                var dataManager = LEUserManagement.getDataManager();
                var gridModel = options.gridModel;
                var agentGroupId = gridModel.getAgentGroupId();
                var agentGroupsCollection = dataManager.getData(dataManager.getEntities().AGENT_GROUP);
                var agentGroupToMoveParent = agentGroupsCollection.get(agentGroupId).get("parentGroupId");
                agentGroupsCollection = agentGroupsCollection.clone();
                AgentGroupUtilities.removeTreeAgentGroupSelected(agentGroupsCollection, agentGroupId);

                var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                var privileges = {viewAll: LEUserManagement.hasEntireAgentGroupTreePrivilege()};

                var valuesArr = [];
                agentGroupsCollection.each(function(agentGroupModel) {
                    if (agentGroupModel.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser) || agentGroupModel.id === agentGroupToMoveParent) {
                        valuesArr.push({id: agentGroupModel.getName(), value: agentGroupModel.getName()});
                    }

                });

                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.agentGroupList.column.name.filter.placeholder")
                };
            }
        },{
            name: "parentGroup",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function (options) {
                var dataManager = LEUserManagement.getDataManager();

                var gridModel = options.gridModel;
                var agentGroupId = gridModel.getAgentGroupId();
                var agentGroupsCollection = dataManager.getData(dataManager.getEntities().AGENT_GROUP);
                var agentGroupToMoveParent = agentGroupsCollection.get(agentGroupId).get("parentGroupId");
                agentGroupsCollection = agentGroupsCollection.clone();
                AgentGroupUtilities.removeTreeAgentGroupSelected(agentGroupsCollection, agentGroupId);

                var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                var privileges = {viewAll: LEUserManagement.hasEntireAgentGroupTreePrivilege()};

                var valuesArr = [];
                agentGroupsCollection.each(function(agentGroupModel) {
                    if (agentGroupModel.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser)) {
                        var parentGroupId = agentGroupModel.getParentGroupId();
                        if (parentGroupId) {//without root of parent groups
                            var parentGroupModel = agentGroupsCollection.get(parentGroupId);
                            valuesArr.push({id: parentGroupId, value: parentGroupModel.getName()});
                        }
                    }
                });

                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.agentGroupList.column.name.filter.placeholder")
                };
            }
        },
            {
                name: "managers",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function (options) {
                    var valuesArr = [];
                    var dataManager = LEUserManagement.getDataManager();
                    var usersCollection = dataManager.getData(dataManager.getEntities().USER);

                    if (LE.sessionManager.hasProfilesFeature()) {
                        var privileges = {viewAll: LEUserManagement.hasEntireAgentGroupTreePrivilege()};
                        var profilesCollection = dataManager.getData(dataManager.getEntities().PROFILES);
                        if (privileges.viewAll) {
                            usersCollection.each(function(userModel) {
                                var userRoles = _.map(userModel.getProfiles(), _.bind(function(userProfileId) {
                                    var profileModel = profilesCollection.get(userProfileId);
                                    return profileModel.getRoleTypeId().toString();
                                }, this));

                                if (_.contains(userRoles, profilesCollection.model.ROLES.AGENT_MANAGER)) {
                                    valuesArr.push({id: userModel.id, value: userModel.getDisplayName()});
                                }
                            });
                        }
                        else {
                            var gridModel = options.gridModel;
                            var agentGroupId = gridModel.getAgentGroupId();
                            var agentGroupsCollection = dataManager.getData(dataManager.getEntities().AGENT_GROUP);
                            var agentGroupToMoveParent = agentGroupsCollection.get(agentGroupId).get("parentGroupId");
                            agentGroupsCollection = agentGroupsCollection.clone();
                            AgentGroupUtilities.removeTreeAgentGroupSelected(agentGroupsCollection, agentGroupId);

                            var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();

                            agentGroupsCollection.each(function(agentGroupModel) {
                                if (agentGroupModel.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser) || agentGroupModel.id === agentGroupToMoveParent) {
                                    _.each(agentGroupModel.getManagers(), function(managerId) {
                                        var userModel = usersCollection.get(managerId);
                                        if (userModel) {
                                            valuesArr.push({id: userModel.id, value: userModel.getDisplayName()});
                                        }
                                    });
                                }
                            });
                        }
                    }
                    else {
                        var permissionGroupCollection = dataManager.getData(dataManager.getEntities().PERMISSION_GROUP);
                        var permissionGroupAgentId;
                        var permissionGroupCampaignManagerId;
                        permissionGroupCollection.each(function(model) {
                            if (model.get("name") === CONST.USER_PERMISSION_GROUP.AGENT){
                                permissionGroupAgentId =  model.get("id");
                            }
                            if (model.get("name") === CONST.USER_PERMISSION_GROUP.CAMPAIGN_MANAGERS){
                                permissionGroupCampaignManagerId =  model.get("id");
                            }
                        });
                        usersCollection.each(function(userModel) {
                            if(userModel.getPermissionGroup().toString() !== permissionGroupAgentId && userModel.getPermissionGroup().toString() !== permissionGroupCampaignManagerId) {
                                valuesArr.push({id: userModel.id, value: userModel.getDisplayName()});
                            }
                        });
                    }


                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEUserManagement.agentGroupList.column.manager.name.filter.placeholder")
                    };
                }
            }];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupMoveFilters;
});
